const accItem = document.getElementsByClassName('wp-block-deepsea-accordionitem');
const accHD = document.getElementsByClassName('accordion-title');

export function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

export function toggleItem(e) {
  const { currentTarget } = e;
  const itemClass = currentTarget.parentNode.className;

  for (let i = 0; i < accItem.length; i += 1) {
    accItem[i].className = 'wp-block-deepsea-accordionitem close';
    accItem[i]
      .querySelector('.accordion-title[aria-expanded="true"]')
      ?.setAttribute('aria-expanded', 'false');
  }

  if (itemClass === 'wp-block-deepsea-accordionitem close') {
    currentTarget.parentNode.className = 'wp-block-deepsea-accordionitem open';
    currentTarget.setAttribute('aria-expanded', 'true');
  }
}

docReady(() => {
  for (let i = 0; i < accHD.length; i += 1) {
    accHD[i].addEventListener('click', toggleItem);
    accHD[i].addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();

        toggleItem(e);
      }
    });
  }
});
